import { all, fork } from 'redux-saga/effects';
import { SharedSagas } from './sagas';
import { AuthSagas } from '../../auth/redux/sagas';
import { OrderSagas } from '../../orders/redux/sagas';
import { OrganizationSagas } from '../../organizations/search/redux/sagas';
import { OrganizationAddEditSagas } from '../../organizations/add-edit/redux/sagas';
import { OrganizationBillingAddEditSagas } from '../../organizationbilling/add-edit/redux/sagas';
import { OrganizationStripeBillingAddEditSagas } from '../../organizationstripebilling/add-edit/redux/sagas';
import { OrganizationBillingReportSagas } from '../../organizationbilling/search/redux/sagas';
import { UsersSagas } from '../../users/search/redux/sagas';
import { UsersAddEditSagas } from '../../users/add-edit/redux/sagas';
import { AccountSagas } from '../../account/redux/sagas';
import { UserGroupsSearchSagas } from '../../userGroups/search/redux/sagas';
import { UserGroupsAddEditSagas } from '../../userGroups/add-edit/redux/sagas';
import { KitsSagas } from '../../kits/redux/sagas';
import { KitOrdersSagas } from '../../kitOrders/redux/sagas';
import { PlatformMaintenanceSagas } from '../../platformMaintenance/redux/sagas';
import { ShipToPatientSagas } from '../../shipToPatient/redux/sagas';
import { PatientPaymentSagas } from '../../patientPayment/redux/sagas';
import { ClinicSubmissionSagas } from '../../clinicSubmission/redux/sagas';
import { OrgSwitcherSagas } from '../../orgSwitcher/redux/sagas';
import { EnterpriseStripeBillingAddEditSagas } from '../../enterpriseStripeBilling/add-edit/redux/sagas';
import { TrackingMaintenanceSagas } from '../../trackingMaintenance/redux/sagas';

const rootSaga = function*() {
    yield all([
        fork(AuthSagas.run),
        fork(SharedSagas.run),
        fork(AccountSagas.run),
        fork(OrderSagas.run),
        fork(OrganizationSagas.run),
        fork(OrganizationAddEditSagas.run),
        fork(OrganizationBillingAddEditSagas.run),
        fork(OrganizationStripeBillingAddEditSagas.run),
        fork(OrganizationBillingReportSagas.run),
        fork(UsersSagas.run),
        fork(UsersAddEditSagas.run),
        fork(UserGroupsSearchSagas.run),
        fork(UserGroupsAddEditSagas.run),
        fork(KitsSagas.run),
        fork(KitOrdersSagas.run),
        fork(PlatformMaintenanceSagas.run),
        fork(ShipToPatientSagas.run),
        fork(PatientPaymentSagas.run),
        fork(ClinicSubmissionSagas.run),
        fork(OrgSwitcherSagas.run),
        fork(EnterpriseStripeBillingAddEditSagas.run),
        fork(TrackingMaintenanceSagas.run),
    ]);
}

export default rootSaga;
